// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Dumpster } from './dumpster';
import { StorageDumpSite } from './storage-dump-site';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class StorageDumpSiteDumpsterLink extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  deleted?: Date;
  dumpsterId!: number;
  storageDumpSiteId!: number;
  dumpster!: Dumpster;
  storageDumpSite!: StorageDumpSite;
}

